import axios from "axios";
import { decryptData, encryptObjectProperties } from "../utils/encryption";

const API_URL = process.env.REACT_APP_API_URL;

export async function getAllUsers() {
  console.log("API_URL====>", API_URL);
  const response = await axios
    .get(API_URL + "/usermaster")
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: [] };
    });
  let result = response.data;
  for (let element of result) {
    const DecryptUserName = decryptData(element.UserName);
    element.UserName = DecryptUserName;
    const DecryptUserEmail = decryptData(element.EmailId);
    element.EmailId = DecryptUserEmail;
    const DecryptuserMobile = decryptData(element.MobileNo);
    element.MobileNo = DecryptuserMobile;
    const DecryptuserAltMobile = element.AlternateMobileNo ? decryptData(element.AlternateMobileNo) : "";
    element.AlternateMobileNo = DecryptuserAltMobile;
  }
  console.log("API_URL====>", result);
  return result;
}

export const userLogin = async (userDetails, accessToken) => {
  let url = API_URL;
  console.log("url====>", url);

  const encryptedUserDetails = encryptObjectProperties(userDetails, ['User']);
  //console.log("encryptedUserDetails while login", encryptedUserDetails);
  const response = await axios
    .post(url + "/login/login",
      { body: encryptedUserDetails })
    .then(function (resp) {
      if (resp.status === 200) {
        // Decrypt sensitive data from response
        const responseData = { ...resp.data };
        if (responseData.UserName) {
          responseData.UserName = decryptData(responseData.UserName);
        }
        if (responseData.UserEmail) {
          responseData.UserEmail = decryptData(responseData.UserEmail);
        }
        if (responseData.mobileNo) {
          responseData.mobileNo = decryptData(responseData.mobileNo);
        }
        if (responseData.altmobileNo) {
          responseData.altmobileNo = decryptData(responseData.altmobileNo);
        }
        if (responseData.userId) {
          responseData.userId = decryptData(responseData.userId);
        }

        sessionStorage.setItem(
          "UserData",
          responseData ? JSON.stringify(responseData) : ""
        );
        sessionStorage.setItem("Token", responseData?.data);
      }
      console.log("resp====>", resp);
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return error;
    });
  return response;
};


export async function getValidUserData(masterName, filterkey, filtervalue) {
  let url = `${API_URL}/usermaster/getValiddata`;
  console.log("getValidUserData ", url);
  let reqBody = { masterName, filterkey, filtervalue }
  const response = await axios
    .post(url, reqBody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: [] };
    });
  console.log(response.data)
  return response.data;

}


export const AddNewUser = async (location) => {
  let url = `${API_URL}/usermaster/adduser`;
  const response = await axios
    .post(url, location)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: { message: "Unable to find request", status: false } };
    });
  console.log("response.data====>", response.data);
  return response.data;
};

export const DeleteUser = async (userId) => {
  let url = `${API_URL}/usermaster/deleteuser`;
  console.log(url)
  let reqBody = { userId }
  const response = await axios
    .post(url, reqBody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: { message: "Unable to find request", status: false } };
    });
  console.log("response.data====>", response.data);
  return response.data;
};

export const UpdateUser = async (userObj) => {
  console.log(userObj);
  console.log(typeof (userObj));
  let url = `${API_URL}/usermaster/updateuser`;
  console.log(url)
  const response = await axios
    .post(url, userObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: { message: "Unable to find request", status: false } };
    });
  console.log("response.data====>", response.data);
  return response.data;
};

//Update User Status to Inactive
export const UpdateUserStatus = async (userObj) => {
  let url = `${API_URL}/usermaster/updateuserstatus`;
  console.log(url)
  const response = await axios
    .post(url, userObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: { message: "Unable to find request", status: false } };
    });
  console.log("response.data====>", response.data);
  return response.data;
};

export async function getHRISActiveUsers() {
  let url = `${API_URL}/usermaster/getactivehrisusers`;
  console.log("getactiveusers ", url);
  const response = await axios
    .get(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: [] };
    });
  console.log("response.data====>", response.data);
  return response.data;
}

export async function getUsersForRole(roleCode) {
  let url = `${API_URL}/usermaster/userrole`;
  let reqBody = { roleCode }
  const response = await axios
    .post(url, reqBody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: [] };
    });
  console.log("response.data====>", response.data);
  return response.data;
}

export async function getDivisions() {
  let url = `${API_URL}/usermaster/getdivisions`;
  console.log("getactiveusers ", url);
  const response = await axios
    .get(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: [] };
    });
  console.log("response.data====>", response.data);
  return response.data;
}

export async function findDivisionalApprover(division, location) {
  try {
    const allUsers = await getAllUsers();
    console.log("findDivisionalApprover(division, location)=====>", division, location);
    
    // Find users with DIVAPPROVER role, same division, and matching location
    const approvers = allUsers.filter(user => {
      if (user.RoleCode !== "DIVAPPROVER" || user.DeleteIndication !== "Active") {
        return false;
      }

      if (user.Division !== division) {
        return false;
      }

      // Check if user's location matches (handle comma-separated locations)
      console.log("user.Location====>",user.Location);
      const userLocations = user.Location ? user.Location.split(",").map(loc => loc.trim()) : [];
      console.log("No divisional error===>userLocations",userLocations);
      return userLocations.includes(location);
    });

    return approvers;
  } catch (error) {
    console.error("Error finding divisional approver:", error);
    return [];
  }
}

export async function getCustomerUsersByCode(bpCode) {
  try {
    const users = await getValidUserData("UserMaster", "UserType", "Customer");
    const matchedUsers = [];

    for (let i = 0; i < users.length; i++) {
      const user = users[i];

      if (user.DeleteIndication !== "Active") {
        continue;
      }

      if (!user.BPCode) {
        continue;
      }

      const userCodes = user.BPCode.split(",");
      let found = false;

      for (let j = 0; j < userCodes.length; j++) {
        const code = userCodes[j].trim();

        if (code === bpCode) {
          found = true;
          break;
        }
      }

      if (found) {
        matchedUsers.push({
          userId: user.UserId,
          userName: decryptData(user.UserName),
          email: decryptData(user.EmailId),
          bpCode: user.BPCode
        });
      }
    }

    return matchedUsers;
  } catch (error) {
    console.error("Error finding customer users:", error);
    return [];
  }
}